export const BUBBLE_CHART_TYPE = 'bubble';
export const BOTTOM_MARGIN = 0;
export const LEFT_MARGIN = 30;
export const RIGHT_MARGIN = 30;
export const TOP_MARGIN = 25;
export const PLOT_BORDER_WIDTH = 0;
export const TOOLTIP_FONT_SIZE = 11;
export const SUB_TOPIC_NAME_TABLE_WIDTH = '15%';
export const COMMENT_COUNT_TABLE_WIDTH = '15%';
export const EMOTION_PERCENTAGE_TABLE_WIDTH = '20%';
export const SUB_TOPIC_DESCRIPTION_TABLE_WIDTH = '40%';
export const MAXIMUM_NUMBER_OF_TOPICS_DISPLAYED = 40;

export const X_KEY = 'x';
export const Y_KEY = 'y';
export const DISTRIBUTION_KEY = 'distribution';
export const SUB_TOPIC_TITLE_KEY = 'subTopicTitle';
export const SUB_TOPIC_DESCRIPTION_KEY = 'subTopicDescription';
export const SUB_TOPIC_TOTAL_COMMENT_COUNT_KEY = 'subTopicTotalCommentCount';
export const SUB_TOPIC_COMMENT_PERCENTAGE_KEY = 'subTopicCommentPercentage';
export const TOP_5_KEYWORDS_KEY = 'top5Keywords';
export const TOP_5_KEYWORDS_FORMATTED_FOR_TOOLTIP_KEY = 'top5KeywordsForTooltip';
export const EMOTION_COMMENT_COUNTS_KEY = 'emotionCommentCounts';
export const EMOTION_PERCENTAGE_COUNTS_KEY = 'emotionPercentageCounts';

export const DATA_KEY = 'data';
export const SUB_TOPICS_KEY = 'subTopics';
export const COUNT_KEY = 'count';

export const BUBBLE_CHART_HEIGHT = 500;
export const BUBBLE_CHART_WIDTH = 500;


// WEBPACK FOOTER //
// ./src/features/shared-components/chart/constants/bubbleChartConstants.js